export default "__VITE_ASSET__Dgo_hG0y__"